// Tiny CSV exporter — no dependency. Builds a CSV string from typed columns
// and triggers a browser download. A UTF-8 BOM is prepended so Excel opens
// accented text correctly.

export interface CsvColumn<T> {
    header: string;
    value: (row: T) => string | number | null | undefined;
}

const escapeCell = (v: string | number | null | undefined): string => {
    const s = v == null ? '' : String(v);
    return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function exportCsv<T>(filename: string, columns: CsvColumn<T>[], rows: T[]): void {
    const head = columns.map((c) => escapeCell(c.header)).join(',');
    const body = rows
        .map((r) => columns.map((c) => escapeCell(c.value(r))).join(','))
        .join('\n');
    const csv = `${head}\n${body}`;
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    triggerDownload(blob, filename.endsWith('.csv') ? filename : `${filename}.csv`);
}

function triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
